import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAdminAccountVenues } from 'hooks/useAccountVenues';
import Select from './Select';

// Admin variant — lists EVERY active account in the system. Footer links to the
// accounts admin page. (Uses the internal /admin/accounts route rather than a
// hardcoded localhost URL so it works in every environment.)
const AdminAccountSwitcher = () => {
  const history = useHistory();
  const { venues } = useAdminAccountVenues();
  const [selectedId, setSelectedId] = useState(null);

  return (
    <Select
      accounts={venues}
      selectedId={selectedId}
      onSelect={setSelectedId}
      headerLabel="Switch account"
      footer={{
        label: 'Manage Accounts',
        onClick: () => history.push('/admin/accounts'),
      }}
    />
  );
};

export default AdminAccountSwitcher;
